
import {
    defineComponent,
    onBeforeMount,
    onMounted,
    reactive,
    ref,
    toRaw
} from "vue";
import Edit from "@/components/cigo-admin-core/pages/template/Edit.vue";
import cigoLayer from "@/components/cigo-layer";

export default defineComponent({
    name: "EditCancer",
    components: {
        Edit
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        let formData = {
            id: props.layerData.recordCurr
                ? props.layerData.recordCurr.id
                : null,
            name: props.layerData.recordCurr
                ? props.layerData.recordCurr.name
                : ""
        };
        const formItemRules = {
            name: [
                {
                    required: true,
                    message: "请输入癌症名称"
                }
            ]
        };

        return {
            formData,
            formItemRules
        };
    }
});
